import React, { useState, useEffect } from 'react'
import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'
import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import DialogLoader from '../../../components/Loader/DialogLoader';
import useStyles from "./styles";
import { withSnackbar } from "./../../../components/Message/Alert";
import { PostDataAPI } from '../../../Services/APIService';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';

function PaymentReceiptDialog({ dialogOpenClose, handleClose,receiptHtml, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
    }, []);
    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Receipt</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>


                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={570}>
                            <div dangerouslySetInnerHTML={{ __html: receiptHtml }} />
                            
                        </Scrollbars>
                    </div>
                </div>
            </Dialog >

        </>
    )
}
export default withSnackbar(PaymentReceiptDialog);